import classNames from "classnames";
import * as React from "react";
import { FC } from "react";
import { understandChildren } from "~/utils/understandChildren";
import * as styles from "./Qtip.less";
import { QTooltip, QTooltipProps } from "./QTooltip";
import { QTooltipOptions } from "./types";

const defaultPosition = {
    my: "top center",
    at: "bottom center",
};

export type QtipProps = QTooltipOptions &
    Pick<QTooltipProps, "showFocus"> & { multiline?: boolean; isVisible?: boolean; cssClass?: string };

export const Qtip: FC<QtipProps> = ({
    showFocus,
    children,
    position = defaultPosition,
    events,
    multiline,
    hide,
    show,
    cssClass,
    isVisible = true,
}) => {
    if (!isVisible) {
        const { target } = understandChildren(children);
        return <>{target}</>;
    }

    const options: QTooltipOptions = {
        position,
        show: {
            delay: 400,
            ...show,
        },
        hide: {
            fixed: true,
            delay: 0,
            ...hide,
        },
        style: {
            classes: classNames(cssClass, multiline && styles.multiline_wrapper),
        },
        events,
    };

    return (
        <QTooltip options={options} lazyInit={true} showFocus={showFocus}>
            {children}
        </QTooltip>
    );
};
